import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const BONUS_CUSTOM_NAME: InjectionToken<string> = new InjectionToken<string>('bonusCustomName');

// eslint-disable-next-line @typescript-eslint/naming-convention
export const BONUSES_FREE_SPINS_ENABLED: InjectionToken<boolean> = new InjectionToken<boolean>('bonusesEnabled', {
  factory: () => true
});
